import * as _ from 'lodash'
import React, { useEffect, useState } from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import emptyKnowledge from '../../assets/New-images/empty-knowledge.svg'
import MoveSelectedModal from '../../components/UI/KnowledgeDatatableComponent/MoveSelectedModal'
import Loading from '../../components/UI/Loading/Loading'
import Pagination from '../../components/UI/Pagination/Pagination'
import PermissionWrapper from '../../components/UI/PermissionWrapper/PermissionWrapper'
import {
  BUILD_SUMMARISE_MULTI_DOCUMENTS_SECTION,
  CREATE_QUIZ_FROM_QUESTION_ID,
  DOCUMENTDETAILBYID,
  KNOWLEDGE_SETUP_CONTEXTUALISED_CHAT,
  TOOLKIT_GENERATE_QNA,
  REVIEW_QUIZ_QUESTIONS,
  SMART_QUIZ_SELECT_PAGES,
  TOOLKIT_GENERATE_LEARNING_OUTCOMES_REVIEW,
  TOOLKIT_GENERATE_LEARNING_OUTCOMES_SELECT_PAGES,
  TOOLKIT_GENERATE_QNA_SELECT_PAGES,
  TOOLKIT_SUMMARISE_DOCUMENTS_SELECT_PAGES,
} from '@/config'
import { HelperService } from '@/services/helper.service'
import {
  bulkAssignModules,
  getAllDocumentsNewFlow,
  getDocumentPreviewUrl,
  restoreDocuments,
  updateBulkDocumentSettings,
  renameDocument,
} from '@/store/knowledge/actions'
import '../Knowledge/AllKnowledge/AllKnowledge.scss'
import DeleteConfirmModal from './DeleteDocumentModal/DeleteConfirmModal'

import { useTranslation } from 'react-i18next'
import TurnOnOffDocumentPreviewModal from './TurnOnOffDocumentPreviewModal/TurnOnOffDocumentPreviewModal'
import SelectSummaryType from '../TeachersToolkit/pages/SummariseDocuments/Popup/SelectSummaryTypePopup'
import classNames from 'classnames'
import DocumentRename from './popup/DocumentRenamePopup'
import SelectModalModule from '../TeachersToolkit/popups/selectModalModule'
import axios from 'axios'
import SelectQuestionTypeModal from '../BuildKnowledgeV2/Step3/popups/SelectQuestionTypeModal'
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  Typography,
} from '@mui/material'
import CustomMenu from '@/components/UI/CustomMenu'

import FilterListIcon from '@mui/icons-material/FilterList'
import { deleteDocuments } from '@/services/KnowledgeService'
import BasicModal from '@/components/UI/Dialog'
import dayjs from 'dayjs'

const UploadedDocuments = (props: any) => {
  const { t } = useTranslation('translation')
  const history = useHistory()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [perPage, setPerPage] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)
  const [showQueType, setShowQueType] = useState(false)
  const [selectedRows, setSelectedRows] = useState([])
  const [documents, setAllDocuments] = useState([])
  const [pagination, setPagination] = useState(null)

  const [bulkAssignCategoryShow, setBulkAssignCategoryShow] = useState(false)
  const [deletedRowId, setDeletedRowId] = useState([])
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState(false)
  const [showDeletePermanentlyModal, setShowDeletePermanentlyModal] =
    useState(false)
  const helperService = new HelperService()

  const [showSelectSummaryType, setShowSelectSummaryType] = useState(false)
  const [showDocumentRenameModal, setShowDocumentRenameModal] = useState(false)
  const [newDocAdded, setNewDocAdded] = useState(false)
  const [query, setQuery] = useState('')
  const [isTyping, setTyping] = useState(false)

  const contextualisedChatStatus: any = {
    new: 'Pending',
    preprocessing: 'Pre-processing',
    created: 'Syncing',
    uploading: 'Syncing',
    uploaded: 'Syncing',
    syncing: 'Syncing',
    synced: 'Synced',
    errored: 'Failed',
    deleted: 'Deleted',
  }

  const [documentPreviewModalShow, setDocumentPreviewModalShow] =
    useState(false)
  const [documentConfirmationMessage, setDocumentConfirmationMessage] =
    useState('')
  const documentPreviewModalhandler = (value: boolean) => {
    setDocumentPreviewModalShow(value)
  }
  const [documentRowId, setDocumentRowId] = useState([])
  const [isDocumentTurnOnMode, setIsDocumentTurnOnMode] = useState(false)
  const [selectBKDisabled, setSelectBKDisabled] = useState(true)

  const [editDocument, setEditDocument] = useState(null)
  const [filters, setFilters] = useState({
    sort_field: 'updated_at',
    sort_order: 'dsc',
    q: '',
    page: 1,
    page_size: 10,
  })

  const turnOnOffDocumentHandler = (
    id: string[],
    turnOnOrOff: boolean = false,
  ) => {
    const msg =
      t('This will ') +
      `${turnOnOrOff ? t('TURN ON ') : t('TURN OFF ')}` +
      t(
        'document preview in WEBCHAT, WIDGET and DIRECT-CHAT for ALL the documents. Do you want to proceed?',
      )
    setIsDocumentTurnOnMode(turnOnOrOff)
    setDocumentConfirmationMessage(msg)
    setDocumentRowId(id)
    setDocumentPreviewModalShow(true)
  }

  useEffect(() => {
    if (props.selectedGroupId) {
      refreshDocuments({ ...filters })
    }
    setSelectedRows([])
  }, [props.selectedGroupId, filters, showDeletePermanentlyModal])

  const refreshDocuments = async (filters: any = null) => {
    const filterMgs =
      props.buildKnowledge && !props.showAllDocuments
        ? props.flowKey === 'SUMMARISE_DOCUMENTS'
          ? { type: 'other' }
          : { type: 'summary' }
        : {}

    const { documents, pagination }: any = await dispatch(
      getAllDocumentsNewFlow(
        filters
          ? {
              ...filters,
              page: currentPage,
              page_size: perPage,
              knowledge_group_ids: props.selectedGroupId,
              ...filterMgs,
            }
          : {
              page: currentPage,
              page_size: perPage,
              knowledge_group_ids: props.selectedGroupId,
              ...filterMgs,
            },
        true,
        props.isArchived,
      ),
    )

    let updatedDocuments = documents.map((d: any) => {
      let isRecentlyUsed = false
      const docuemnt30TimeStamp =
        new Date(d.updated_at).getTime() + 30 * 24 * 60 * 60 * 1000
      const current = new Date().getTime()

      if (docuemnt30TimeStamp > current) {
        isRecentlyUsed = true
      }
      return {
        ...d,
        isRecentlyUsed: isRecentlyUsed,
      }
    })

    setAllDocuments(updatedDocuments)
    setPagination(pagination)
  }

  const onSortHandler = (selector: any, direction: string) => {
    setFilters({
      ...filters,
      sort_field: selector,
      sort_order: direction === 'desc' ? 'dsc' : 'asc',
    })
  }

  /**
   *
   * @param page Pagination on change of page
   */
  const handlePageChange = (page: number) => {
    setCurrentPage(page)
    setFilters({
      ...filters,
      page: page,
    })
  }
  /**
   * Used to paginate data based on per page and page number
   * @param newPerPage
   * @param page
   */
  const handlePerRowsChange = async (newPerPage: number, page: number) => {
    setPerPage(newPerPage)
    setCurrentPage(page)
    setFilters({
      ...filters,
      page: page,
      page_size: newPerPage,
    })
  }

  const deleteConfirmed = async (
    isArchiving: boolean = false,
    deleteIntents: boolean = false,
  ) => {
    setLoading(true)
    try {
      await deleteDocuments(
        typeof deletedRowId === 'string' ? [deletedRowId] : deletedRowId,
        deleteIntents,
        isArchiving,
      )
      setSelectedRows([])
      setLoading(false)
    } catch (error: any) {
      setLoading(false)
    } finally {
      setShowDeletePermanentlyModal(false)
    }
  }

  const restoreArchived = async (selectedRowIds: string[]) => {
    setLoading(true)
    try {
      await dispatch(restoreDocuments(selectedRowIds))
      await refreshDocuments()
      setSelectedRows([])
      setLoading(false)
    } catch (error: any) {
      setLoading(false)
    }
  }

  const updateTurnOnOffConfirmed = async (
    e: React.ChangeEvent<HTMLInputElement>,
    data: {
      selectedRow: string[]
      isDocumentTurnOnMode: boolean
      is_full_document_allowed: boolean
    },
  ) => {
    e.preventDefault()
    documentPreviewModalhandler(false)
    setLoading(true)
    try {
      await dispatch(
        updateBulkDocumentSettings(
          typeof data.selectedRow === 'string'
            ? [data.selectedRow]
            : data.selectedRow,
          {
            settings: {
              allowed_channels: data.isDocumentTurnOnMode
                ? ['webchat', 'widget', 'direct-chat']
                : [],
              is_full_document_allowed: data.isDocumentTurnOnMode
                ? data.is_full_document_allowed
                : false,
            },
          },
        ),
      )
      setSelectedRows([])
      setLoading(false)
    } catch (error: any) {
      setSelectedRows([])
      setLoading(false)
    }
  }

  const addToSelectedRows = (event: any, id: string) => {
    let data: any[] =
      props.createFromUploadedDocument && !props.isContexualised
        ? []
        : [...selectedRows]
    if (event.target.checked) {
      const isPresent = data.indexOf(id)
      if (isPresent < 0) {
        data.push(id)
      }
    } else {
      const oldData = [...selectedRows]
      const index = oldData.indexOf(id)
      oldData.splice(index, 1)
      data = [...oldData]
    }
    setSelectedRows([..._.uniq(data)])
    if (props.createFromUploadedDocument) {
      props.setSelectedDoc([..._.uniq(data)])
    }

    if ([..._.uniq(data)].length > 0 && [..._.uniq(data)].length <= 5)
      setSelectBKDisabled(false)
    else setSelectBKDisabled(true)
  }

  const onSelectAllRows = (event: any) => {
    if (event.target.checked) {
      if (documents && documents.length > 0) {
        let data: any[] = [...documents.map((intent: any) => intent._id)]
        setSelectedRows([...data])
      }
    } else {
      setSelectedRows([])
    }
  }

  // Show bulk assign category modal
  const BulkAssignCategoryhandler = (value: boolean) => {
    setBulkAssignCategoryShow(value)
  }
  const bulkAssignCategoryKnowledgeHandler = (id: string[]) => {
    setBulkAssignCategoryShow(true)
  }

  const confirmCategoryUpdateHandler = async (selectedOption: any) => {
    try {
      BulkAssignCategoryhandler(false)
      await dispatch(
        bulkAssignModules(selectedOption, selectedRows, 'document'),
      )
      setSelectedRows([])
      refreshDocuments()
    } catch (error: any) {
      setSelectedRows([])
    }
  }

  const downloadDocumentHandler = async (documentId: String, index: any) => {
    const oldDocuments = documents
    const currDocument = oldDocuments[index]
    currDocument.loading = true
    setAllDocuments([...oldDocuments])
    try {
      let previewUrlResponse: any = await dispatch(
        getDocumentPreviewUrl(documentId, null, true),
      )
      const data: any = await previewUrlResponse
      const arr = Object.values(data)
      const url = Object.values(arr[0])
      let extension =
        url && url.length > 0 && url[0].preview_url !== null
          ? url[0].preview_url.split('.').at(-1)
          : ''

      if (url[0].preview_url !== null) {
        axios
          .get(url[0].preview_url, {
            headers: {
              'Content-Type': 'application/octet-stream',
            },
            responseType: 'blob',
          })
          .then(response => {
            const a = document.createElement('a')
            const objUrl = window.URL.createObjectURL(response.data)
            a.href = objUrl
            a.download =
              url[0].name.replace(`.${extension}`, '') + '.' + extension
            a.click()
          })
          .catch(err => {
            console.log('error', err)
          })
      } else {
        helperService.showToaster(
          t(
            'We are not able to download the file at the moment. Please try again after sometime.',
          ),
        )
      }
      currDocument.loading = false
      setAllDocuments([...oldDocuments])
    } catch (error) {
      helperService.showToaster(
        t(
          'We are not able to download the file at the moment. Please try again after sometime.',
        ),
      )
    }
  }

  const docRename = (value: boolean) => {
    setShowDocumentRenameModal(value)
  }

  const showDocumentRename = (doc: any) => {
    if (doc) {
      setEditDocument(doc)
      docRename(true)
    }
  }

  const DocumentRenameHandler = async (fileName: string) => {
    if (fileName) {
      setLoading(true)
      try {
        let res: any = await dispatch(
          renameDocument(editDocument._id, fileName),
        )
        if (res) {
          let temp = [...documents]
          const doc = documents.findIndex(d => d._id === res._id)
          temp[doc] = res
          setAllDocuments(temp)
        }
        docRename(false)
        setLoading(false)
        setEditDocument(null)
      } catch (error) {
        docRename(false)
        setLoading(false)
        setEditDocument(null)
      }
    }
  }

  const generateQuesHandler = async (doc: any) => {
    if (doc && showQueType) {
      let isAllDocumentTypes: boolean = false
      let summaryDocumentType: any[] = []
      const group = props.toolkitSelectedGroupId || props.selectedGroupId
      const temp = documents.filter((docs: any) => {
        return selectedRows.some((id: any) => id === docs._id)
      })

      if (temp && temp.length > 0) {
        const groupedDocuments = _.groupBy(temp, 'type')
        isAllDocumentTypes = temp.some((i: any) => i.type !== 'summary')
        for (const key in groupedDocuments) {
          summaryDocumentType = groupedDocuments.summary.map(i => i._id)
        }
      }

      if (!isAllDocumentTypes) {
        const queTypes =
          doc.types && doc.types.length > 0
            ? `&queTypes=${doc.types.join(',')}`
            : ''

        const queCount =
          doc.queCount && doc.queCount > 0 ? `&queCount=${doc.queCount}` : ''

        history.push(
          `${REVIEW_QUIZ_QUESTIONS}?group=${
            group
          }&document=${summaryDocumentType.join(',')}${queTypes}&quizId=${props.toolkitQuizId}${queCount}&through=knowledge-base`,
          {
            questionTypes: props.toolkitQuestionTypes,
            quizId: props.toolkitQuizId,
            queTypes: queTypes,
            queCount: queCount,
          },
        )
      }
    }
  }

  const selectDocumentsHandler = (selectedOption: any = '') => {
    let isAllDocumentTypes: boolean = false
    let otherDocumentType: any[] = []
    let summaryDocumentType: any[] = []
    const group =
      selectedOption || props.toolkitSelectedGroupId || props.selectedGroupId
    const temp = documents.filter((doc: any) => {
      return selectedRows.some((id: any) => id === doc._id)
    })
    if (temp && temp.length > 0) {
      const groupedDocuments = _.groupBy(temp, 'type')
      isAllDocumentTypes = temp.some((i: any) => i.type !== 'summary')
      for (const key in groupedDocuments) {
        if (key !== 'summary') {
          otherDocumentType.push(groupedDocuments[key].map(i => i._id))
        } else {
          summaryDocumentType = groupedDocuments.summary.map(i => i._id)
        }
      }
    }

    const summaryParam =
      summaryDocumentType && summaryDocumentType.length > 0
        ? `&summaryTypeDocuments=${summaryDocumentType.join(',')}`
        : ''
    setSelectBKDisabled(true)
    setSelectedRows([])
    switch (props.flowKey) {
      case 'SMART_QUIZ':
        if (isAllDocumentTypes) {
          history.push(
            `${SMART_QUIZ_SELECT_PAGES}?group=${
              group
            }&documents=${otherDocumentType.join(
              ',',
            )}&quizId=${props.toolkitQuizId ? props.toolkitQuizId : ''}${summaryParam}`,
            {
              questionTypes: props.toolkitQuestionTypes,
              quizId: props.toolkitQuizId,
            },
          )
        } else {
          setSelectedRows(selectedRows)
          setNewDocAdded(false)
          setShowQueType(true)
        }
        break
      case 'GENERATE_KNOWLEDGE':
        if (isAllDocumentTypes) {
          history.push(
            `${TOOLKIT_GENERATE_QNA_SELECT_PAGES}?documents=${otherDocumentType.join(
              ',',
            )}&group=${group}${summaryParam}`,
          )
        } else {
          history.push(
            `${TOOLKIT_GENERATE_QNA}?question=${summaryDocumentType.join(
              ',',
            )}&group=${group}&through=documents`,
          )
        }
        break
      case 'SUMMARISE_DOCUMENTS':
        if (selectedRows.length > 1) {
          setShowSelectSummaryType(true)
        } else {
          history.push(
            `${TOOLKIT_SUMMARISE_DOCUMENTS_SELECT_PAGES}?documents=${selectedRows.join(
              ',',
            )}&group=${group}&through=documents&summary-type=single`,
          )
        }
        break
      case 'LEARNING_OUTCOMES':
        if (isAllDocumentTypes) {
          history.push(
            `${TOOLKIT_GENERATE_LEARNING_OUTCOMES_SELECT_PAGES}?documents=${otherDocumentType.join(
              ',',
            )}&group=${group}${summaryParam}`,
          )
        } else {
          history.push(
            `${TOOLKIT_GENERATE_LEARNING_OUTCOMES_REVIEW}?document=${summaryDocumentType.join(
              ',',
            )}&group=${group}`,
          )
        }
        break
      default:
        history.push(
          `${BUILD_SUMMARISE_MULTI_DOCUMENTS_SECTION.replace(
            ':step',
            '3',
          ).replace(':subStep', '2')}?group=${
            group
          }&documents=${selectedRows.join(',')}&type=${props.type}`,
        )
        break
    }
  }

  /**
   * Set debounce time for while searching in any input
   */

  useEffect(() => {
    // Added 500 as debounce time will wait for 500 miliseconds and then we will fetch intents based on query
    const delayDebounceFn = setTimeout(() => {
      if (isTyping) {
        setCurrentPage(1)
        setFilters({
          ...filters,
          q: query,
        })
        setTyping(false)
      }
    }, 500)
    return () => clearTimeout(delayDebounceFn)
  }, [query])

  const onInputChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault()
    setQuery(e.target.value)
    setTyping(true)
  }

  if (loading) {
    return <Loading />
  }

  return (
    <React.Fragment>
      <DeleteConfirmModal
        show={showDeletePermanentlyModal}
        onClickDelete={deleteIntents => {
          deleteConfirmed(false, deleteIntents)
        }}
        onClickCancel={() => {
          setShowDeletePermanentlyModal(false)
        }}
        onClickClose={() => setShowDeletePermanentlyModal(false)}
      />

      <SelectQuestionTypeModal
        show={showQueType}
        onProceed={(d: any, queCount: number) => {
          const types = d.map((i: any) => i.type)
          generateQuesHandler({
            types,
            queCount,
          })
        }}
        type="summaries_document"
      />

      <TurnOnOffDocumentPreviewModal
        message={documentConfirmationMessage}
        size={'md'}
        show={documentPreviewModalShow}
        selectedRow={documentRowId}
        isDocumentTurnOnMode={isDocumentTurnOnMode}
        onHide={() => documentPreviewModalhandler(false)}
        confirmHandler={updateTurnOnOffConfirmed}
      />
      <BasicModal
        open={showDeleteConfirmationModal}
        onClose={() => setShowDeleteConfirmationModal(false)}
        title={t('Remove Document')}
        sx={{ width: 430, height: 'auto' }}
        footerActions={[
          {
            title: t('Delete'),
            variant: 'outlined',
            color: 'error',
            onClick: () => {
              setShowDeleteConfirmationModal(false)
              setShowDeletePermanentlyModal(true)
            },
          },
          {
            title: t('Archive'),
            variant: 'contained',
            onClick: () => {
              setShowDeleteConfirmationModal(false)
              deleteConfirmed(true, false)
            },
          },
        ]}
      >
        <Typography variant="body3" mt={2}>
          {t(
            'Would you like to archive or delete the document(s) from Knowledge base?',
          )}
        </Typography>
      </BasicModal>
      <MoveSelectedModal
        show={bulkAssignCategoryShow}
        onHide={() => BulkAssignCategoryhandler(false)}
        confirmCategoryUpdate={confirmCategoryUpdateHandler}
        groupId={props?.selectedGroupId}
      />

      <SelectSummaryType
        show={showSelectSummaryType}
        onHide={() => {
          setShowSelectSummaryType(false)
        }}
        documents={selectedRows}
        selectFromKnowledgeBase
        groups={props.toolkitSelectedGroupId || props.selectedGroupId}
      />

      <DocumentRename
        show={showDocumentRenameModal}
        onHide={() => {
          docRename(false)
        }}
        footerButtonAction={DocumentRenameHandler}
        documentName={editDocument?.name || editDocument?.file_name}
      />

      <SelectModalModule
        show={newDocAdded}
        onHide={() => setNewDocAdded(false)}
        confirmCategoryUpdate={(selectedOption: any) =>
          selectDocumentsHandler(selectedOption)
        }
        header={props.popupProperties?.header}
        subHeader={props.popupProperties?.subHeader}
        selectedFlow={props.popupProperties?.selectedFlow}
      />

      <div className="all-knowledge-search tw-flex tw-flex-wrap tw-items-center tw-gap-2">
        {!props.createFromUploadedDocument && (
          <CustomMenu
            textTrigger={t('Sort')}
            options={[
              {
                label: t('Most Recent'),
                onClick: () => onSortHandler('updated_at', 'desc'),
              },
              {
                label: t('Ascending'),
                onClick: () => onSortHandler('name', 'asc'),
              },
              {
                label: t('Descending'),
                onClick: () => onSortHandler('name', 'desc'),
              },
            ]}
            slotProps={{
              trigger: {
                startIcon: <FilterListIcon fontSize="small" />,
                size: 'small',
                variant: 'outlined',
                sx: { padding: '8px 12px', fontWeight: 700 },
              },
            }}
          />
        )}

        {!props.createFromUploadedDocument && (
          <div className="web-links my-0 mr-0">
            <input
              type="text"
              className="form-control h-auto"
              placeholder="Search for Documents"
              onChange={onInputChangeHandler}
            />
          </div>
        )}

        {!props.createFromUploadedDocument &&
          !props.buildKnowledge &&
          !props.buildV2 && (
            <Button
              sx={{ ml: 'auto' }}
              onClick={() => {
                history.push(
                  KNOWLEDGE_SETUP_CONTEXTUALISED_CHAT +
                    (props.queryString || ''),
                )
              }}
            >
              {'+ Add'}
            </Button>
          )}

        {props.buildKnowledge && (
          <Button
            sx={{ ml: 'auto' }}
            variant="contained"
            disabled={selectBKDisabled}
            onClick={() => {
              if (props.selectedGroupId || props.toolkitSelectedGroupId) {
                selectDocumentsHandler()
              } else {
                setNewDocAdded(true)
              }
            }}
          >
            {'Select Document(s)'}
          </Button>
        )}

        {props.createFromUploadedDocument &&
          !props.addMoreQuestionFromDocument &&
          !props.isContexualised &&
          !props.buildKnowledge && (
            <button
              className="btn btn-primary ml-auto py-1"
              onClick={() => {
                history.push(
                  CREATE_QUIZ_FROM_QUESTION_ID.replace(
                    ':questionId',
                    selectedRows[0],
                  ) +
                    `?quizId=${
                      props.isEditQuiz && props.quizId ? props.quizId : ''
                    }`,
                  {
                    createFromUploadedDocument:
                      props.isEditQuiz && props.quizId
                        ? !props.createFromUploadedDocument
                        : props.createFromUploadedDocument,
                    queryString: props.queryString,
                    isEditQuiz: props.isEditQuiz,
                    quizId: props.quizId,
                  },
                )
              }}
              disabled={selectedRows.length === 0}
            >
              {'Import Knowledge'}
            </button>
          )}
      </div>

      {props.buildKnowledge && (
        <div className="mt-2">
          <small>
            {t('Please select up to a maximum of')} 5 {t('documents in total')}.
          </small>
        </div>
      )}

      {!props.createFromUploadedDocument && (
        <div className="d-flex flex-wrap justify-content-between align-items-center mt-1">
          <div className="d-flex align-items-center">
            {!props.buildKnowledge && documents?.length > 0 && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={
                      selectedRows.length === documents.length &&
                      documents.length > 0
                    }
                    onChange={(e: any) => onSelectAllRows(e)}
                  />
                }
                label={t('Select all')}
                sx={{ margin: 0 }}
              />
            )}
            <PermissionWrapper>
              {selectedRows.length > 0 && !props.buildKnowledge && (
                <>
                  <Button
                    onClick={() => turnOnOffDocumentHandler(selectedRows, true)}
                  >
                    {t('Turn On Document Preview')}
                  </Button>
                  <Button
                    color="error"
                    onClick={() =>
                      turnOnOffDocumentHandler(selectedRows, false)
                    }
                  >
                    {t('Turn Off Document Preview')}
                  </Button>
                  <Button
                    color="error"
                    onClick={() => {
                      setDeletedRowId(selectedRows)
                      if (props.isArchived) {
                        setShowDeletePermanentlyModal(true)
                      } else {
                        setShowDeleteConfirmationModal(true)
                      }
                    }}
                  >
                    {t('Delete Document(s)')}
                  </Button>
                  {props.isArchived && (
                    <Button
                      color="error"
                      onClick={() => restoreArchived(selectedRows)}
                    >
                      {t('Restore Document(s)')}
                    </Button>
                  )}
                  <Button
                    onClick={e =>
                      bulkAssignCategoryKnowledgeHandler(selectedRows)
                    }
                  >
                    {t('Move Selected')}
                  </Button>
                </>
              )}
            </PermissionWrapper>
          </div>
        </div>
      )}
      <div
        className={classNames({
          'accordion-viewby document-details': true,
          'document-isContexualised': props.isContexualised,
        })}
      >
        {!loading &&
          documents.map((document: any, index: number) => {
            return (
              <Card key={'new_' + document._id + '_' + index}>
                <Stack
                  direction="row"
                  alignItems="center"
                  gap={2}
                  px={2}
                  py={1}
                >
                  <Checkbox
                    checked={selectedRows.indexOf(document._id) >= 0}
                    onChange={e => {
                      addToSelectedRows(e, document._id)
                    }}
                  />
                  <Stack>
                    <Typography
                      component="p"
                      sx={{ fontSize: '14px', fontWeight: 600 }}
                    >
                      {document.name || document.file_name}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: '12px',
                        fontWeight: 400,
                        color: '#5F5E5E',
                      }}
                    >
                      {document.breadcrumbs
                        ?.map((item: any) => item.name)
                        ?.join('/')}
                    </Typography>
                  </Stack>
                </Stack>
                {!props.isContexualised && (
                  <Box className="tw-p-5 tw-bg-[#F8F7F8] tw-rounded-lg">
                    <Row>
                      <Col
                        md={
                          document &&
                          !document.hasOwnProperty('search_index_status')
                            ? 4
                            : 3
                        }
                        className="my-2 my-md-0"
                      >
                        <h3 className="clr-black mb-1">{t('Uploaded By')}</h3>
                        <div>{document.author_email}</div>
                      </Col>
                      <Col
                        md={
                          document &&
                          !document.hasOwnProperty('search_index_status')
                            ? 4
                            : 3
                        }
                        className="my-2 my-md-0"
                      >
                        <h3 className="clr-black mb-1">{t('Upload Date')}</h3>
                        <div>
                          {dayjs
                            .utc(document.created_at)
                            .local()
                            .format('DD/MM/yyyy hh:mm A')}
                        </div>
                      </Col>
                      <Col
                        md={
                          document &&
                          !document.hasOwnProperty('search_index_status')
                            ? 4
                            : 3
                        }
                        className="my-2 my-md-0"
                      >
                        <h3 className="clr-black mb-1">
                          {t('Document Preview')}
                        </h3>
                        <div>
                          {document &&
                            document.settings &&
                            document.settings.allowed_channels.length === 3 &&
                            document.settings.allowed_channels.indexOf(
                              'webchat',
                            ) >= 0 &&
                            document.settings.allowed_channels.indexOf(
                              'widget',
                            ) >= 0 &&
                            document.settings.allowed_channels.indexOf(
                              'direct-chat',
                            ) >= 0 &&
                            t('Both Web & Chat Widget')}

                          {document &&
                            document.settings &&
                            document.settings.allowed_channels.length === 1 &&
                            document.settings.allowed_channels.indexOf(
                              'webchat',
                            ) >= 0 &&
                            t('Web Chat')}

                          {document &&
                            document.settings &&
                            document.settings.allowed_channels.length === 2 &&
                            document.settings.allowed_channels.indexOf(
                              'widget',
                            ) >= 0 &&
                            document.settings.allowed_channels.indexOf(
                              'direct-chat',
                            ) >= 0 &&
                            t('Chat Widget')}
                        </div>
                      </Col>
                      {document &&
                        document.hasOwnProperty('search_index_status') && (
                          <Col md={3} className="my-2 my-md-0">
                            <h3 className="clr-black mb-1">
                              {t('Contextualised Chat')}
                            </h3>

                            <div>
                              {contextualisedChatStatus[
                                document.search_index_status
                              ] || ''}
                            </div>
                          </Col>
                        )}
                    </Row>
                    {!props.buildKnowledge && (
                      <div className="mt-3">
                        <h3 className="clr-black">{t('Key Phrases')}</h3>
                        <div className="located-tags d-flex flex-wrap align-items-center">
                          {!document.hasOwnProperty('keyphrases') ||
                          document.keyphrases.length === 0 ? (
                            <span>{t('No Key Phrase found')}</span>
                          ) : (
                            <>
                              {document.keyphrases
                                .slice(0, 7)
                                .map((tag: string, index: number) => {
                                  return (
                                    <div key={tag + '_' + index}>{tag}</div>
                                  )
                                })}
                              {document.keyphrases.length > 8 && (
                                <button className="btn p-0 font-weight-bold clr-grey-txt7 py-0 px-2">
                                  +{document.keyphrases.length - 8}
                                </button>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    )}

                    <Stack
                      direction="row"
                      mt={2}
                      spacing={2}
                      justifyContent="flex-end"
                    >
                      {!props.createFromUploadedDocument &&
                        !props.buildKnowledge && (
                          <Button
                            variant="outlined"
                            onClick={() => showDocumentRename(document)}
                          >
                            {t('Rename Document')}
                          </Button>
                        )}
                      {!props.isArchived &&
                        document.is_downloadable &&
                        !props.buildKnowledge &&
                        !props.createFromUploadedDocument && (
                          <Button
                            variant="outlined"
                            onClick={() => {
                              downloadDocumentHandler(document._id, index)
                            }}
                            disabled={!!document.loading}
                          >
                            {document.loading && (
                              <span className="doc-loader spinner-width-20 mr-2 mb-0"></span>
                            )}{' '}
                            {t('Download Document')}
                          </Button>
                        )}
                      {!props.isArchived &&
                        !props.buildKnowledge &&
                        !props.createFromUploadedDocument &&
                        (document.flow !== 'v2' ||
                          document.hasOwnProperty('search_index_status')) && (
                          <Button
                            variant="outlined"
                            onClick={() => {
                              history.push(
                                DOCUMENTDETAILBYID.replace(
                                  ':documentId',
                                  document._id,
                                ) +
                                  '?question=' +
                                  document._id +
                                  '&type=' +
                                  document?.type,
                                {
                                  showQuestions: true,
                                },
                              )
                            }}
                          >
                            {t('Manage Document')}
                          </Button>
                        )}
                      {props.isArchived &&
                        !props.buildKnowledge &&
                        !props.createFromUploadedDocument && (
                          <Button
                            variant="outlined"
                            onClick={() => restoreArchived([document._id])}
                          >
                            {t('Restore')}
                          </Button>
                        )}
                      {!props.buildKnowledge &&
                        !props.createFromUploadedDocument && (
                          <Button
                            variant="outlined"
                            color="error"
                            onClick={() => {
                              setDeletedRowId([document._id])
                              if (props.isArchived) {
                                setShowDeletePermanentlyModal(true)
                              } else {
                                setShowDeleteConfirmationModal(true)
                              }
                            }}
                          >
                            {t('Delete')}
                          </Button>
                        )}
                    </Stack>
                  </Box>
                )}
              </Card>
            )
          })}
      </div>

      {pagination && documents && documents.length > 0 && (
        <Pagination
          currentPage={currentPage}
          pagination={pagination}
          paginationPerPage={perPage}
          pageChange={handlePerRowsChange}
          onChangePage={handlePageChange}
          style={{ position: 'relative' }}
        />
      )}

      {documents && documents.length === 0 && (
        <div className="empty-knowledge text-center my-2">
          <h3 className="h6 clr-grey-txt7 mb-3">
            {t(
              'No document uploaded in this module. Click the button below to upload document.',
            )}
          </h3>
          <figure className="h-auto">
            <img src={emptyKnowledge} alt="" />
          </figure>
          <div className="clr-primary font-weight-bold">
            <Link
              to={
                KNOWLEDGE_SETUP_CONTEXTUALISED_CHAT + (props.queryString || '')
              }
            >
              {t('Click here to get started')}
            </Link>
          </div>
        </div>
      )}
    </React.Fragment>
  )
}

export default UploadedDocuments
